<template lang="pug">
.enjoy-travel-v1-contioner
  .ladder-line-one
    .top-icon 特权1
    div(style='display:flex;margin-top:-0.03rem')
      div() 生活出行卡券・开卡领
      div.red-word {{propsList.length}}
      div 张券
  .one-line-block
    .one-line-block-card(v-if="version!=='ladder_blend_two'" @click="openModal")
      couponsItems(v-for="(item,index) in firstList"
        :cardInfo="item"
        :cardBackground="'https://m.hellobike.com/resource/helloyun/08345/YEcvK_bg1.png?x-oss-process=image/quality,q_80'"
        :cardWidth="'0.6rem'"
        :cardHeight="'0.79rem'"
        :index="index"
        :isHaveExpanSion="(item.vipExtendProperty?true:false)"
        :expanSionBg="'https://m.hellobike.com/resource/helloyun/08345/E2IwKvKP-Y.png?x-oss-process=image/quality,q_80'"
        :expanSionW="'1.25rem'"
        :expanSionH="'0.8rem'"
        :cardClass="'ladder_travle'"
        )
    .one-line-block-card-two(v-else @click="openModal")
      .one-line-block-card-padding
        couponsItems(v-for="(item,index) in firstList"
          :cardInfo="item"
          :cardBackground="''"
          :cardWidth="'0.59rem'"
          :cardHeight="'0.78rem'"
          :index="index"
          :isHaveExpanSion="(item.vipExtendProperty?true:false)"
          :expanSionBg="'https://m.hellobike.com/resource/helloyun/08345/E2IwKvKP-Y.png?x-oss-process=image/quality,q_80'"
          :expanSionW="'1.25rem'"
          :expanSionH="'0.8rem'"
          :cardClass="'ladder-two'"
          )
      .red-bottom-line
        .red-icon
          img.first-img(src="https://m.hellobike.com/resource/gallery/61/NUZeCpof_Group%201707483021.png?x-oss-process=image/quality,q_80")
          img(src="https://m.hellobike.com/resource/gallery/61/cohGLQ1l_Group%201707483020.png?x-oss-process=image/quality,q_80")
        .red-word 顺风车/打车通用
  .two-line-block
    .two-line-one-line-block-card(@click="openModal")
      couponsItems(v-for="(item,index) in secondList"
        :cardInfo="item"
        :cardBackground="'https://m.hellobike.com/resource/helloyun/08345/YEcvK_bg1.png?x-oss-process=image/quality,q_80'"
        :cardWidth="'0.6rem'"
        :cardHeight="'0.79rem'"
        :index="index"
        :isHaveExpanSion="(item.vipExtendProperty?true:false)"
        :expanSionBg="'https://m.hellobike.com/resource/helloyun/08345/E2IwKvKP-Y.png?x-oss-process=image/quality,q_80'"
        :expanSionW="'1.25rem'"
        :expanSionH="'0.8rem'"
        :class="'ladder_travle'")
      .end-block(v-if="propsList.length>10")
        .end-block-info
          .end-big-word-font {{endSum}}
          .end-small-word-font 元
        .end-block-middle-info 含{{lessCard}}张
        .end-block-bottom-info 其他
  .bottom-word(v-if="showBottom")  限时升级权益仅首月生效，次月起恢复成原权益
  </template>
<script>
import lifeCardBussiness from './life-card-bussiness.vue';
import couponsItems from './coupons-Items.vue';
import { couponsData } from '../utils';


export default {
  components: {
    lifeCardBussiness,
    couponsItems,
  },
  props: {
    ladderPropGroupList: {
      type: Array,
      required: true,
    },
    ladderDetailMap: {
      type: Object,
      required: true,
    },
    groupList: {
      type: Array,
      required: true,
    },
    allPropList: {
      type: Array,
      default: () => [],
    },
    version: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      isHaveExpanSion: true,
    };
  },
  computed: {
    propsList() {
      return couponsData(this.allPropList, this.version);
    },
    firstList() {
      const tempList = this.propsList.slice(0, 5).filter((x) => x.vipExtendProperty);
      return this.propsList.slice(0, (5 - tempList.length));
    },
    secondList() {
      // eslint-disable-next-line max-len
      const tempList = this.propsList.slice(this.firstList.length, 9).filter((x) => x.vipExtendProperty);

      const tempFirstList = this.propsList.slice(0, 5).filter((x) => x.vipExtendProperty);
      if (tempList.length > 0) {
        return this.propsList.slice(this.firstList.length, (9 - tempList.length * 2 + 1));
      }
      return this.propsList.slice(this.firstList.length, (9 - tempFirstList.length));
    },
    endSum() {
      return this.propsList.slice(9).reduce((acc, cur) => acc + cur.amount, 0).toFixed(0);
    },
    lessCard() {
      return this.propsList.length - this.firstList.length - this.secondList.length;
    },
    showBottom() {
      const tempList = this.propsList.filter((x) => x.vipExtendProperty);
      if (tempList.length > 0) {
        return true;
      } return false;
    },
  },
  watch: {
  },
  mounted() {
  },
  methods: {
    openModal() {
      if (this.version === 'ladder_blend_two') return;
      this.$emit('openModal');
    },
  },
};
</script>
<style lang="less" scoped>
.enjoy-travel-v1-contioner {
  background: #fff;

  .ladder-line-one {
    padding: 0 0.15rem;
    color: #242729;
    font-family: PingFangSC-Medium, PingFang SC, sans-serif;
    font-size: 0.15rem;
    font-weight: 500;
    display: flex;
    line-height: 0.22rem;
    margin-top: -0.03rem;

    .red-word {
      color: #f54311;
      font-weight: 700;
      font-size: 0.2rem;
      line-height: 0.2rem;
    }

    .top-icon {
      background: linear-gradient(90deg, #76737c 0%, #36363c 100%);
      height: 0.18rem;
      border-radius: 0.1rem 0.02rem 0.1rem 0.02rem;
      color: #fffae8;
      font-size: 0.12rem;
      text-align: center;
      line-height: 0.18rem;
      padding: 0 0.05rem;
      margin-right: 0.05rem;
    }
  }

  .one-line-block {
    line-height: 0.2rem;
    font-size: 0.14rem;
    font-family: PingFangSC-Regular, PingFang SC, sans-serif;
    font-weight: 400;
    color: #242729;
    padding: 0 0.15rem 0 0.1rem;

    .one-line-block-title {
      display: flex;

      img {
        width: 0.62rem;
        height: 0.2rem;
      }

      .word {
        margin-left: 0.08rem;
      }
    }

    .one-line-block-card {
      margin-top: 0.12rem;
      display: flex;
      justify-content: space-between;

      .one-line-block-card-block {
        width: 0.6rem;
        height: 0.79rem;
        background-image: url(https://m.hellobike.com/resource/helloyun/08345/YEcvK_bg1.png?x-oss-process=image/quality,q_80);
        background-size: 100% 100%;
        margin-left: 0.05rem;

        .one-block-info {
          text-align: center;
          display: flex;
          justify-content: center;

          .big-word-font {
            margin-top: 0.03rem;
            font-size: 0.26rem;
            font-family: DINAlternate-Bold, DINAlternate, sans-serif;
            font-weight: bold;
            color: #f54311;
            line-height: 0.3rem;
          }

          .small-word-font {
            margin-top: 0.12rem;
            font-size: 0.11rem;
            font-family: PingFangSC-Regular, PingFang SC, sans-serif;
            font-weight: 400;
            color: #f54311;
            margin-left: 0.01rem;
          }
        }

        .one-block-middle-info {
          text-align: center;
          font-size: 0.11rem;
          font-family: PingFangSC-Regular, PingFang SC, sans-serif;
          font-weight: 400;
          color: #c5a399;
          line-height: 0.16rem;
          margin-top: -0.02rem;
        }

        .one-block-bottom-info {
          text-align: center;
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC, sans-serif;
          color: #fef8ea;
          line-height: 20px;
          margin-top: 0.06rem;
          font-weight: 500;
        }
      }
    }

    .one-line-block-card-two {
      margin-top: 0.26rem;
      width: 100%;
      height: 0.74rem;
      background: linear-gradient(0.02deg, #e43f11 21.68%, #fa5222 93.67%);
      border-radius: 0.1rem;
      position: relative;

      .one-line-block-card-padding {
        padding: 0 0.04rem;
        display: flex;
        justify-content: space-between;
      }

      .red-bottom-line {
        position: absolute;
        bottom: 0;
        width: 100%;
        height: 0.38rem;
        background-image: url('https://m.hellobike.com/resource/gallery/61/2No8YFeVW4.png?x-oss-process=image/quality,q_80');
        background-size: 100% 100%;
        display: flex;
        justify-content: center;

        .red-icon {
          margin-top: 0.12rem;

          img.first-img {
            margin-right: -0.05rem;
          }

          img {
            width: 0.18rem;
            height: 0.18rem;
            border-radius: 50%;
            border: 0.01rem solid #fc6638;
            background: #fff;
          }
        }

        .red-word {
          margin-top: 0.12rem;
          margin-left: 0.04rem;
          font-family: PingFangSC-Regular, PingFang SC, sans-serif;
          font-weight: 600;
          font-size: 0.14rem;
          line-height: 0.196rem;
          text-align: center;
          color: #fff;
        }
      }
    }
  }

  .two-line-block {
    line-height: 0.2rem;
    font-size: 0.14rem;
    font-family: PingFangSC-Regular, PingFang SC, sans-serif;
    font-weight: 400;
    color: #242729;
    padding: 0 0.15rem 0 0.1rem;

    .two-line-one-line-block-card {
      margin-top: 0.12rem;
      display: flex;
      justify-content: space-between;

      .end-block {
        margin-left: 0.05rem;
        width: 0.6rem;
        height: 0.79rem;
        background-image: url(https://m.hellobike.com/resource/helloyun/08345/fPFXm_bg2.png?x-oss-process=image/quality,q_80);
        background-size: 100% 100%;

        .end-block-info {
          text-align: center;
          display: flex;
          justify-content: center;
          margin-top: 0.02rem;

          .end-big-word-font {
            margin-top: 0.03rem;
            font-size: 0.26rem;
            font-family: DINAlternate-Bold, DINAlternate, sans-serif;
            font-weight: bold;
            color: #f54311;
            line-height: 0.3rem;
          }

          .end-small-word-font {
            margin-top: 0.12rem;
            font-size: 0.11rem;
            font-family: PingFangSC-Regular, PingFang SC, sans-serif;
            font-weight: 400;
            color: #f54311;
            margin-left: 0.01rem;
          }
        }

        .end-block-middle-info {
          text-align: center;
          font-size: 0.11rem;
          font-family: PingFangSC-Regular, PingFang SC, sans-serif;
          font-weight: 400;
          color: #c5a399;
          line-height: 0.16rem;
          margin-top: -0.02rem;
        }

        .end-block-bottom-info {
          text-align: center;
          font-size: 0.14rem;
          font-family: PingFangSC-Regular, PingFang SC, sans-serif;
          font-weight: 400;
          color: #fef8ea;
          line-height: 20px;
          margin-top: 0.06rem;
        }
      }
    }
  }

  .bottom-word {
    margin-top: 0.08rem;
    font-family: PingFangSC-Regular, PingFang SC, sans-serif;
    font-size: 0.11rem;
    font-weight: 400;
    line-height: 0.16rem;
    color: #879099;
    padding: 0 0.2rem;
  }
}
</style>
